var debounce = require('lodash/debounce');
var gtm = require('googletagmanager/tagManager');
var endpoint = $('.modal-suggestions-wrapper').data('url');
var minChars = $('.page-header .search-field').length > 0 ? $('.search-field').attr('data-query-length') : 3;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;
var $trendingSearchesSection = $('.trending-searches');

/*eslint-disable */
function getSuggestionsWrapper(scope) {
    return $('.modal-suggestions-wrapper');
}

function getSuggestionOptions() {
    return $('.modal-suggestions-wrapper .item[id]');
}

function setComboboxExpandedState(isExpanded) {
    $('input.search-field').attr('aria-expanded', isExpanded ? 'true' : 'false');

    if (!isExpanded) {
        $('input.search-field').removeAttr('aria-activedescendant');
    }
}

function updateSearchDescribedBy() {
    if (getSuggestionOptions().length > 0) {
        $('input.search-field').attr('aria-describedby', 'search-result-count');
    } else {
        $('input.search-field').removeAttr('aria-describedby');
    }
}

function syncComboboxAriaState() {
    var hasOptions = getSuggestionOptions().length > 0;
    setComboboxExpandedState(hasOptions);
    updateSearchDescribedBy();
}

function setSearchModalTriggerExpandedState(isExpanded) {
    $('[data-toggle="modal"][data-target="#searchModal"]').attr('aria-expanded', isExpanded ? 'true' : 'false');
}


function clearModals() {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
}


function tearDownSuggestions() {
    $('input.search-field').val('');
    clearModals();
    $('.search-mobile .suggestions').unbind('scroll');
    $('.modal-suggestions-wrapper').empty();
    setComboboxExpandedState(false);
    $('input.search-field').removeAttr('aria-describedby');
    toggleSuggestionsIcon('search');
    $('.reset-button').addClass('d-none');
}

function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile button.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
}

function processEmptySuggestionResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    $.spinner().stop();
    $trendingSearchesSection.addClass('d-none');

    if (typeof response !== 'object') {
        $suggestionsWrapper.append(response).show();
        syncComboboxAriaState();
    } else {
        $suggestionsWrapper.hide();
        setComboboxExpandedState(false);
        $('input.search-field').removeAttr('aria-describedby');
    }
}

function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    $.spinner().stop();
    $trendingSearchesSection.addClass('d-none');

    if (typeof response !== 'object') {
        $suggestionsWrapper.append(response).show();
        $(this).siblings('.reset-button').removeClass('d-none');
        syncComboboxAriaState();
    } else {
        $suggestionsWrapper.hide();
        setComboboxExpandedState(false);
        $('input.search-field').removeAttr('aria-describedby');
    }
}

function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        $.spinner().start();
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else if (($(scope).val().length === 0 || $(scope).val().length === 1 || $(scope).val().length === 2) && $(scope).data('enable-empty-suggestions') === true || $(scope).data('enable-empty-suggestions') === 'true') {
        if ($('.js-empty-search-suggestions').length > 0 && $('.js-empty-search-suggestions a').length > 0) {
            $(scope).siblings('.reset-button').addClass('d-none');
            syncComboboxAriaState();
            $.spinner().stop();
            return;
        }

        $.spinner().start();
        $.ajax({
            context: scope,
            url: $('.modal-suggestions-wrapper').data('empty-search-suggestion-url'),
            method: 'GET',
            success: processEmptySuggestionResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        toggleSuggestionsIcon('search');
        $(scope).siblings('.reset-button').addClass('d-none');
        clearModals();
        getSuggestionsWrapper(scope).empty();
        setComboboxExpandedState(false);
        $('input.search-field').removeAttr('aria-describedby');
    }
}

function handleArrow(direction) {
    var suggestionsList = getSuggestionOptions();

    if (suggestionsList.length === 0) {
        return;
    }

    var $target;
    if (suggestionsList.filter('.selected').length === 0) {
        $target = suggestionsList.first().addClass('selected');
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $target = suggestionsList.eq(idx).length ? suggestionsList.eq(idx) : suggestionsList.first();
                $target.addClass('selected');
                return false;
            }
        });
    }

    if ($target && $target.length && $target[0].id) {
        $('input.search-field').attr('aria-activedescendant', $target[0].id);
    }
}

function resetInputField() {
    var $input = $(this).siblings('.search-field');
    $input.val('').focus();
    $(this).addClass('d-none');
    getSuggestionsWrapper(this).empty();
    setComboboxExpandedState(false);
    $input.removeAttr('aria-describedby');
    $trendingSearchesSection.removeClass('d-none');
}

module.exports = function () {
    // Submit form only if nothing is selected
    $('form[name="simpleSearch"]').submit(function (e) {
        var suggestionsList = getSuggestionOptions();
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    // Search field key handlers
    $('input.search-field').each(function () {
        var debounceSuggestions = debounce(getSuggestions, 300);

        $(this).on('keyup focus', function (e) {
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault();
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault();
                    break;
                default:
                    debounceSuggestions(this, e);
            }

            if ($(this).val().length > 0) {
                $(this).siblings('.reset-button').removeClass('d-none');
            } else {
                $(this).siblings('.reset-button').addClass('d-none');
            }
        });

    });

    $(document).on('click', '.reset-button', resetInputField);

    // Fire searchSuggestionClick when a user clicks an autocomplete suggestion.
    $(document).on('click', '.modal-suggestions-wrapper .search-suggestions-item a', function () {
        var $item = $(this).closest('.search-suggestions-item');
        var id = $item.attr('id') || '';
        var parts = id.split('-');
        var type = parts[0] || '';
        if (['product', 'content', 'category'].indexOf(type) === -1) { return; }
        var position = parseInt(parts[parts.length - 1], 10);
        var typedTerm = $('input.search-field').val() ? $('input.search-field').val().trim() : '';
        var suggestionText = $item.find('.search-suggestions-item__text').text().trim()
            || $(this).attr('aria-label')
            || $(this).text().trim();
        gtm.searchSuggestionClick({
            term: typedTerm,
            suggestionText: suggestionText,
            suggestionPosition: isNaN(position) ? null : position + 1,
            suggestionType: type
        });
    });

    $('#searchModal').on('show.bs.modal shown.bs.modal', function (event) {

        if (event.type === 'show') {
            setSearchModalTriggerExpandedState(true);
            $('body').trigger('header:updateHeaderOffset', [true]);
        } else if (event.type === 'shown') {
            $('.modal-backdrop').addClass('search-suggestions-backdrop');
            // Trigger a click on the js-search-input element
            $('.js-search-input').focus();
        }
    });

    $('#searchModal').on('hidden.bs.modal', function () {
        setSearchModalTriggerExpandedState(false);
        $('.reset-button').each(function () {
            resetInputField.call(this);
        });
    });

   $('.search-input__wrapper[data-toggle="modal"]').on('keydown', function (e) {
        var target = $(this).data('target');
       var isNativeButton = $(this).is('button');

       // Open modal on Enter for all trigger types and Space for non-native fallback triggers.
       if (e.which === 13 || (!isNativeButton && e.which === 32)) { // Enter or Space
            e.preventDefault();
            $(target).modal('show');
        }
        // Open modal on any alphanumeric or printable character
        else if ((e.which >= 48 && e.which <= 90) ||  // 0-9, A-Z
                 (e.which >= 96 && e.which <= 111) || // Numpad 0-9 and operators
                 (e.which >= 186 && e.which <= 222)) { // Punctuation
            e.preventDefault();
            var $modal = $(target);
            var char = String.fromCharCode(e.which).toLowerCase();
            $modal.modal('show');
            $modal.one('shown.bs.modal', function () {
                $('.js-search-input').val(char).focus().trigger('keyup');
            });
        }
    });
}